import { Bar } from 'vue-chartjs'

const OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  legend: { display: false },
  scales: {
    yAxes: [{ ticks: { beginAtZero: true }, gridLines: { color: '#eef1f0' } }],
    xAxes: [{ gridLines: { display: false } }]
  }
}

export default {
  extends: Bar,
  props: ['chartData'],
  mounted () {
    this.renderChart(this.chartData, OPTIONS)
  },
  watch: {
    chartData: {
      handler (val) {
        if (this.$data._chart) this.$data._chart.destroy()
        this.renderChart(val, OPTIONS)
      },
      deep: true
    }
  }
}
